import { overlay } from "overlay-kit";

import { AddOrRenameCourseModal } from "./AddOrRenameCourseModal";

import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";
import { ADMIN_COURSE_EVENT_PREFIX } from "utils/amplitude";

export const showAddCourseModal = (defaultGroupingId?: string) =>
  overlay.open(({ isOpen, unmount }) => (
    <Dialog open={isOpen} title={t("home.courses.add_course_heading")} onClose={unmount}>
      <AddOrRenameCourseModal
        defaultGroupingId={defaultGroupingId}
        eventPrefix={`${ADMIN_COURSE_EVENT_PREFIX}Add Course`}
        onClose={unmount}
      />
    </Dialog>
  ));

export const showRenameCourseModal = (courseId: string) =>
  overlay.open(({ isOpen, unmount }) => (
    <Dialog open={isOpen} title={t("home.courses.rename_course_heading")} onClose={unmount}>
      <AddOrRenameCourseModal
        courseId={courseId}
        eventPrefix={`${ADMIN_COURSE_EVENT_PREFIX}Rename Course`}
        onClose={unmount}
      />
    </Dialog>
  ));
